import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./TeamSection.css";

export default function TeamSlider() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    fetchTeam();
  }, []);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const fetchTeam = async () => {
    try {
      const res = await axios.get("https://vangal-backend.onrender.com/api/team");
      setMembers(res.data);
    } catch (err) {
      console.error("Failed to fetch team", err);
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: !isMobile,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: isMobile ? 2500 : 3500,
    pauseOnHover: !isMobile,
    adaptiveHeight: true,
    arrows: false,
    swipeToSlide: true,
    centerMode: isMobile,
    centerPadding: isMobile ? "40px" : "0px",
    appendDots: dots => (
      <div>
        <ul className="vf-dots">{dots}</ul>
      </div>
    )
  };

  if (loading) return null;

  return (
    <section className="vf-team-section vf-container">
      <div className="vf-team-header">
        <h2 className="vf-team-title">Meet Our Team</h2>
        <p className="vf-team-subtitle">
          Professionals who ensure quality & freshness
        </p>
      </div>

      <Slider className="vf-team-slider" {...settings}>
        {members.map(member => (
          <div key={member.id} className="vf-team-slide">
            <article className="vf-team-card">
              <div className="vf-team-photo-wrap">
                <img
                  src={member.img}
                  alt={member.name}
                  className="vf-team-photo"
                />
              </div>
              <div className="vf-team-info">
                <h3 className="vf-team-name">{member.name}</h3>
                <p className="vf-team-role">{member.designation}</p>
              </div>
            </article>
          </div>
        ))}
      </Slider>
    </section>
  );
}
